import styled from 'styled-components'
import { Input } from 'antd'

const CodeInputBoxStyled = styled(Input)`
  display: flex;
  text-align: center;
`

export default CodeInputBoxStyled
